module.exports = __webpack_public_path__ + "img/logo_w.2ebd040e.svg";